module.exports = __webpack_public_path__ + "media/images/icons/energie-icons-strategie-und-energieplanung-706d50092166511a45f047ae847dba9d.svg";